module.exports = __webpack_public_path__ + "static/media/c7da8588-5302-43fa-9200-368b6ba96eba.4e97bc9c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/c7da8588-5302-43fa-9200-368b6ba96eba.pdf
// module id = 2041
// module chunks = 1